import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './theme/tokens.css';
import './theme/fonts.css';
import './theme/layout.css';
import './components/components.css';

import App from './App.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { ComputeCreditProvider } from './context/ComputeCreditContext.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ComputeCreditProvider>
          <App />
        </ComputeCreditProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
